if (!window.Eurus.loadedScript.has('card-product-gallery.js')) {
  window.Eurus.loadedScript.add('card-product-gallery.js');

  document.addEventListener('alpine:init', () => {
    Alpine.data('xCardProductGallery', (slideCount, transitionStyle, readyEvent) => ({
      collectionProductGalleryLoaded: false,
      collectionProductGalleryResizeObserver: null,
      showGalleryArrows: false,
      revealGalleryArrows() {
        this.showGalleryArrows = true;
      },
      hideGalleryArrows() {
        this.showGalleryArrows = false;
      },
      loadCollectionProductGallery() {
        if (this.collectionProductGalleryLoaded || this.$el.splide) return;

        if (!window.Splide) {
          setTimeout(() => this.loadCollectionProductGallery(), 50);
          return;
        }

        this.collectionProductGalleryLoaded = true;

        const collectionProductGalleryConfig = {
          pagination: slideCount > 1,
          perPage: 1,
          perMove: 1,
          gap: 20,
          drag: true,
          noDrag: 'model-viewer',
          classes: {
            pagination: 'splide__pagination product-media-pagination',
            page: 'product-media-pagination__button none_border'
          },
          events: [
            {
              event: 'ready',
              callback: () => {
                document.dispatchEvent(new CustomEvent(readyEvent));
              }
            }
          ]
        };

        if (transitionStyle === 'default') {
          collectionProductGalleryConfig.type = 'loop';
        } else {
          collectionProductGalleryConfig.rewind = true;
          collectionProductGalleryConfig.type = 'fade';
        }

        const collectionProductGallery = new Splide(this.$el, collectionProductGalleryConfig);

        collectionProductGallery.on('mounted resized', () => {
          const collectionProductGalleryTrack = collectionProductGallery.root.querySelector('.splide__track');

          if (!collectionProductGalleryTrack) return;

          collectionProductGallery.Components.Slides.get().forEach((slideItem) => {
            slideItem.slide.style.height = `${collectionProductGalleryTrack.offsetHeight}px`;
          });
        });

        this.$el.splide = collectionProductGallery;
        collectionProductGallery.mount();

        const collectionProductGalleryCard = this.$el.closest('.collection-list-product-card');
        const collectionProductGalleryGrid = this.$el.closest('#ProductGridContainer');
        const refreshCollectionProductGallery = () => {
          requestAnimationFrame(() => collectionProductGallery.refresh());
        };

        if (window.ResizeObserver) {
          this.collectionProductGalleryResizeObserver = new ResizeObserver(refreshCollectionProductGallery);
          this.collectionProductGalleryResizeObserver.observe(this.$el);
          this.collectionProductGalleryResizeObserver.observe(collectionProductGalleryCard || this.$el);

          if (collectionProductGalleryGrid) {
            this.collectionProductGalleryResizeObserver.observe(collectionProductGalleryGrid);
          }
        }

        collectionProductGalleryGrid?.addEventListener('transitionend', refreshCollectionProductGallery);

        document.addEventListener('eurus:collection-product-gallery:refresh', () => collectionProductGallery.refresh());
      }
    }));
  });
}
